module.exports = __webpack_public_path__ + "img/组 6@2x.0849b5e3.png";